import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Y2021Component } from './y2021.component';


const routes: Routes = [{
  path: '',
  component: Y2021Component
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class Y2021RoutingModule { }
